import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Badge, Card, Dropdown } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useLocation } from "react-router-dom";
import dummmyImg from "../../images/profile/images.jpeg";
import FullImage from "../components/Modal/FullImage";
import toast from "react-hot-toast";
import verification2 from "../../images/svg/verified2.svg";
import Spinner from "../components/Common/Spinner";
import WarningIconWithTooltip from "../components/WarningIconWithToolTip";
import {
  activeJobServicePostingData,
  deleteJobPostingData,
  deleteServicePostingData,
  getJobDetails,
  getServiceDetails,
} from "../../services/UserServices/UserService";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";

export default function JobDetails() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dataId = searchParams.get("data");
  const location = useLocation();
  const userId = location?.state?.data ? location?.state?.data : dataId;
  const type = location?.state?.type ? location?.state?.type : "job";
  const [data, setData] = useState({});
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState("");
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [jobId, setJobId] = useState(null);

  const [imageType, setImageType] = useState("image");
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const handleFetch = async () => {
    setLoader(true);
    if (type === "job") {
      try {
        const response = await getJobDetails(userId);
        setData(response.data?.data);
        setLoader(false);
      } catch (error) {
        console.error(error, "error");
        setLoader(false);
      }
    } else {
      try {
        const response = await getServiceDetails(userId);
        setData(response.data?.data);
        setLoader(false);
      } catch (error) {
        console.error(error, "error");
        setLoader(false);
      }
    }
  };

  const ImageWithCrossIcon = ({ image, index }) => (
    <>
      <div className="position-relative">
        <img
          src={image ? image : dummmyImg}
          width={index === 0 ? 177 : 83}
          height={index === 0 ? 177 : 83}
          className="text-center pointer rounded"
          style={{ transition: "width 0.5s, height 0.5s" }}
          onClick={() => {
            if (image) {
              setImageForView(image);
              setView(true);
              setImageType("image");
            }
          }}
        />
      </div>
    </>
  );

  useEffect(() => {
    handleFetch();
  }, []);

  async function handleDeleteComponent() {
    setLoader(true);
    if (type === "job") {
      try {
        const res = await deleteJobPostingData(jobId);
        handleFetch();
        setLoader(false);
        setDeleteAccount(false);
        navigate("/job-posting");
        toast.success("Job deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoader(false);
      }
    } else {
      try {
        const res = await deleteServicePostingData(jobId);
        handleFetch();
        setLoader(false);
        setDeleteAccount(false);
        navigate("/service-posting");
        toast.success("Service deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoader(false);
      }
    }
  }

  async function handleActiveComponent(jobId, resourceType, isBlocked) {
    setLoader(true);
    try {
      const res = await activeJobServicePostingData({
        postId: jobId,
        resourceType,
        isActive: !isBlocked,
      });
      handleFetch();
      setLoader(false);
      toast.success(" successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoader(false);
    }
  }

  return (
    <div>
      <PageTitle
        activeMenu={type === "job" ? "Job Details" : "Service Details"}
        motherMenu={type === "job" ? "Job" : "Service"}
        previousPath={type === "job" ? "/job-posting" : "/service-posting"}
        stateData={location?.state?.selectedTab}
        stateDataPage={location?.state?.page}
        search={location?.state?.search}
      />
      <Card>
        {loader ? (
          <Spinner />
        ) : (
          <Card.Header className="d-block align-items-start">
            <div
              className="d-block d-sm-flex justify-content-start"
              style={{ gap: "1rem" }}
            >
              <div>
                <div>
                  <div className="d-flex  gap-2">
                    {[0].map((item) => (
                      <ImageWithCrossIcon
                        key={item}
                        image={data?.imageUrl?.[item]}
                        index={item}
                      />
                    ))}

                    <div className="d-flex flex-column gap-2 justify-content-between">
                      {[1, 2].map((item) => (
                        <ImageWithCrossIcon
                          key={item}
                          image={data?.imageUrl?.[item]}
                          index={item}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="d-flex pt-3 mb-3 gap-2">
                    {[3, 4].map((item) => (
                      <ImageWithCrossIcon
                        key={item}
                        image={data?.imageUrl?.[item]}
                        index={item}
                      />
                    ))}
                  </div>
                </div>
              </div>
              <div className="text-left flex-grow-1">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="text-color">
                    {data?.title}{" "}
                    {data?.isDeleted && (
                      <Badge bg="" className="badge-secondary fs-12">
                        Deleted
                      </Badge>
                    )}
                    {data?.reasonsToDeleteImages && <WarningIconWithTooltip />}
                  </h3>
                  <div className="d-flex justify-content-between align-items-center gap-1">
                    {!data?.isReported && (
                      <div className="bg-circle">
                        <img src={verification2} />
                      </div>
                    )}
                    {data?.isReported && (
                      <Badge bg="" className="badge-danger fs-12">
                        Reported
                      </Badge>
                    )}
                    {!data?.isDeleted && (
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="info light"
                          className="light sharp btn btn-info i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              handleActiveComponent(
                                data?._id,
                                type,
                                data?.isReported
                              );
                            }}
                          >
                            {data?.isReported ? "Active" : "Report"}
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setDeleteAccount(true);
                              setJobId(data?._id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                </div>

                <div className="d-block d-md-flex gap-5">
                  <div>
                    <p>
                      Name - <b>{data?.postedBy?.name}</b>
                    </p>
                    <p>
                      Zip - <b>{data?.address?.zip}</b>
                    </p>
                    <p>
                      category - <b>{data?.category?.name}</b>
                    </p>
                    <p>
                      Created At -{" "}
                      <b>
                        {data?.createdAt &&
                          moment(data?.createdAt).format("MMM Do YYYY, h:mm a")}
                      </b>
                    </p>
                    {data?.gender === "male" && (
                      <p>
                        Member -{" "}
                        <b>
                          {data?.isPremium
                            ? "yes"
                            : data?.subscription?.subscriptionPeriod
                            ? "Past Member"
                            : "No"}
                        </b>
                      </p>
                    )}
                    <p className="pointer">
                      User Id - <b>{data?._id}</b>
                    </p>
                    {(data?.isPremium ||
                      data?.subscription?.subscriptionPeriod) &&
                      data?.gender === "male" && (
                        <p>
                          Duration -{" "}
                          <b>
                            {data?.subscription?.isLifetime
                              ? "Lifetime"
                              : data?.subscription?.subscriptionPeriod}
                          </b>
                        </p>
                      )}
                  </div>
                  <div className="">
                    <p>
                      Email - <b>{data?.postedBy?.email}</b>
                    </p>

                    <p>
                      Phone Number -{" "}
                      <b>
                        {data?.postedBy?.countryCode &&
                          "+" + data?.postedBy?.countryCode}{" "}
                        {data?.postedBy?.phoneNumber}
                      </b>
                    </p>
                    {data?.subCategory?.name && (
                      <p>
                        subCategory - <b>{data?.subCategory?.name}</b>
                      </p>
                    )}
                    <p>
                      Location - <b>{data?.address?.name}</b>
                    </p>
                  </div>
                </div>
                <br />
                <p>
                  <b>Description - </b>
                </p>
                <br />
                {Array.isArray(data?.description) ? (
                  data.description.map((item, idx) => (
                    <div key={idx} className="mb-3">
                      {item.question && <h6 className="fw-bold mb-1">{item.question}</h6>}
                      {item.answer && <p className="mb-2 text-secondary">{item.answer}</p>}
                    </div>
                  ))
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                )}
              </div>
            </div>
          </Card.Header>
        )}
      </Card>
      {view && (
        <FullImage
          show={view}
          image={imageForView}
          onHide={() => setView(false)}
          imageType={imageType}
        />
      )}
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleDeleteComponent}
        type={type}
      />
    </div>
  );
}
